import styled, { css } from 'styled-components';
import { Scrollbar } from '../../theme';
import { getFontStyle, rem, toRemString } from '../../utils';
export const StyledTextArea = styled.textarea `
  width: 100%;
  ${getFontStyle('Body')};

  ${({ theme, resize, disabled }) => css `
    color: ${disabled ? theme.Color.Neutrals.Gray : theme.Color.Neutrals.Dark};
    flex: 1;
    padding: ${rem(theme.Spacing.Size.Small)};
    border: none;
    box-shadow: ${toRemString([0, 0, 0, 1])} inset
      ${theme.Color.Neutrals.Border};
    border-radius: ${rem(theme.Form.TextArea.Radius)};
    resize: ${resize && !disabled ? resize : 'none'};
    background-color: ${disabled
    ? theme.Color.Neutrals.Light
    : theme.Components.Panel.Background};
    outline: none;
    transition: box-shadow ${theme.Transition.Timing.Out};

    ${Scrollbar.Default}

    &:focus,
  &:hover {
      box-shadow: ${({ theme }) => toRemString([0, 0, 0, theme.Border.Size.Medium])}
        inset ${theme.Color.Brand.Primary};
      transition: border-color ${theme.Transition.Timing.In};
    }

    &:read-only {
      box-shadow: ${toRemString([0, 0, 0, 1])} inset
        ${theme.Color.Overlay.Light};
    }

    &::placeholder {
      opacity: unset;
      color: ${theme.Color.Neutrals.Gray};
    }
  `}
`;
//# sourceMappingURL=TextArea.style.js.map